/**
 * Public profile URLs use `/profile/{username}`; guard against null/undefined coerced to strings.
 */
export function isValidProfileUsername(username) {
  if (username === null || username === undefined) {
    return false;
  }

  const value = String(username).trim();
  if (!value) {
    return false;
  }

  const lowered = value.toLowerCase();
  return lowered !== "null" && lowered !== "undefined";
}

export function buildProfilePath(username) {
  return isValidProfileUsername(username) ? `/profile/${username}` : null;
}
